/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { XIcon16Light } from './XIcon16Light';
import { XIcon16Regular } from './XIcon16Regular';
import { XIcon16Solid } from './XIcon16Solid';
import { XIcon20Light } from './XIcon20Light';
import { XIcon20Regular } from './XIcon20Regular';
import { XIcon20Solid } from './XIcon20Solid';
import { XIcon24Regular } from './XIcon24Regular';
import { XIcon24Solid } from './XIcon24Solid';
import { XIcon32Regular } from './XIcon32Regular';
import { XIcon64Regular } from './XIcon64Regular';
var sizes = {
    16: {
        light: XIcon16Light,
        regular: XIcon16Regular,
        solid: XIcon16Solid,
    },
    20: {
        light: XIcon20Light,
        regular: XIcon20Regular,
        solid: XIcon20Solid,
    },
    24: {
        regular: XIcon24Regular,
        solid: XIcon24Solid,
    },
    32: {
        regular: XIcon32Regular,
    },
    64: {
        regular: XIcon64Regular,
    },
};
export var XIcon = forwardRef('XIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
